module.exports = __webpack_public_path__ + "static/media/Rectangle 319.48352142.svg";